function copy(value, context) {
  if (value == null)
    return void 0;
  return {
    ...value,
    elements: value.elements.map((element) => context.copyElement(element))
  };
}
export {
  copy
};
//# sourceMappingURL=grid.js.map